// src/pages/WayliRawVesselConsignees.jsx
import React from "react";
import WayliRawTablePage from "./WayliRawTablePage";

export default function WayliRawVesselConsignees() {
  return (
    <WayliRawTablePage
      title="raw_vessel_consignees"
      endpoint="/api/public/raw-vessel-consignees"
      selectAllByDefault
    />
  );
}
